var _style, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3228px",
    height: "1000px",
    viewBox: "0 0 3228 1000",
    style: {
      enableBackground: "new 0 0 3228 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AOK_Signet_Small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B_x5F_S_x5F_neg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "B_x5F_S_x5F_pos_00000147181916722232795040000014446553568878002834_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "AOK_Signet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B_x5F_M_x5F_neg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "B_x5F_M_x5F_pos"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "AOK_Logo_Vert_Small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V_x5F_S_x5F_neg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V_x5F_S_x5F_pos_00000114761522986583039130000005618946789575720860_"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "AOK_Logo_Vert"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V_x5F_M_x5F_neg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V_x5F_M_x5F_pos"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "AOK_Logo_Horiz_Small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H_x5F_S_x5F_neg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H_x5F_S_x5F_pos_00000098212570917392331050000003381745887596959647_"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "AOK_Logo_Horiz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H_x5F_M_x5F_neg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H_x5F_M_x5F_pos"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    x: 0,
    className: "st0",
    width: 3228,
    height: 1000
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1078,128c-205.44232,0-372,166.57739-372,371.99939C706,705.44196,872.55768,872,1078,872 c205.42285,0,372-166.55804,372-372.00061C1450,294.57739,1283.42285,128,1078,128z M1078.00354,750 c-136.69104,0-247.48425-111.98169-247.48425-250.02484C830.51929,361.93439,941.3125,250,1078.00354,250 c136.67297,0,247.51575,111.93439,247.51575,249.97516C1325.51929,638.01831,1214.67651,750,1078.00354,750z  M2928.56372,391.72632c-18.75879,0.00122-35.51636,4.21149-53.09814,14.362 c-47.41479,27.37592-65.85742,81.74585-52.30786,129.83496l-67.84302,39.16907V411.63208 c48.74829-12.0744,86.8689-55.63922,86.8689-110.64563c0-58.03839-38.6543-85.90704-114.10962-161.36237 c-75.74609,75.7475-114.09131,103.17609-114.09131,161.36237c0,52.07385,35.84106,98.21967,86.67236,110.68689v163.39722 l-67.80933-39.1521c13.54126-48.08667-4.90112-102.44818-52.31128-129.82043c-17.58179-10.15051-34.33936-14.362-53.09814-14.362 c-34.87036,0-76.67603,14.53778-143.69604,32.49542c27.7251,103.47131,32.30371,150.40143,82.69385,179.49396 c17.72949,10.23657,37.44727,15.23364,57.05005,15.23364c29.84155,0,59.33667-11.68646,81.22583-33.99988l95.94507,55.39679V720 H2466v55h524v-55h-234.6853v-79.64648l95.97314-55.40765c21.89014,22.3158,51.38647,34.00348,81.22925,34.00348 c19.60156,0,39.32056-4.99707,57.04883-15.23364c50.39111-29.09253,54.96875-76.02264,82.69385-179.49396 C3005.23975,406.2641,2963.43408,391.72388,2928.56372,391.72632z M2574.87695,534.62854 c-10.72388,18.57471-29.96533,29.66351-51.47119,29.66351c-10.47803,0-20.75439-2.73492-29.7168-7.90894 c-20.10229-11.60651-26.53345-27.70569-43.60107-93.80212c34.20459-9.54315,59.45654-16.17804,77.26978-16.17804 c9.7688,0,16.99268,1.97363,25.76489,7.03857C2581.50342,469.82684,2591.26221,506.24762,2574.87695,534.62854z  M2728.00439,360.42017c-32.77148,0-59.43335-26.66193-59.43335-59.43372c0-23.21051,10.72876-36.83423,59.42749-84.6554 c48.69995,47.85632,59.43945,61.52856,59.43945,84.6554C2787.43799,333.75824,2760.77637,360.42017,2728.00439,360.42017z  M2962.15527,556.37341c-8.96362,5.17523-19.23901,7.91016-29.7168,7.91016c-21.50708,0-40.74854-11.09003-51.47241-29.66473 c-7.68823-13.31458-9.88501-29.61499-6.02759-44.72131c3.94604-15.45062,13.81299-28.40155,27.78198-36.46692 c8.771-5.06372,15.99731-7.03729,25.77563-7.03729c17.80981,0,43.06055,6.63483,77.26025,16.17798 C2988.68872,528.66772,2982.25635,544.76813,2962.15527,556.37341z M2728,1c-275.58105,0-499,223.44653-499,498.9986 C2229,775.58051,2452.41895,999,2728,999c275.55396,0,499-223.41949,499-499.0014C3227,224.44653,3003.55396,1,2728,1z M2728,944 c-244.82275,0-444-199.17834-444-444.0014C2284,255.17694,2483.17725,56,2728,56s444,199.17694,444,443.9986 C3172,744.82166,2972.82275,944,2728,944z M1813.48022,455.89911l302.91675,392.09845h-164.73145h-0.03271L1727.448,551.98871 L1629,661.4436V848h-120V152h120v330.16211L1925.18335,152h160.38916L1813.48022,455.89911z M1,848h145.35236l98.00623-150H532 v150h120V152H457.7832L1,848z M532,589H315.57642L532,257.76044V589z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAok);
export default __webpack_public_path__ + "static/media/aok.048ecb6814b11db2bb84aed03740bf4e.svg";
export { ForwardRef as ReactComponent };